import { render } from "./ProfileWithoutSearch.vue?vue&type=template&id=4dc6c50a"
import script from "./ProfileWithoutSearch.vue?vue&type=script&lang=js"
export * from "./ProfileWithoutSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__